import { baseApi } from "../baseApi";

export const shipmentApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getTransporterSuppliers: builder.query({
      query: () => ({
        url: `/api/resource/Supplier`,
        method: 'GET',
        params: {
          filters: JSON.stringify({ is_transporter: 1 }),
        },
      }),
    }),
    getDrivers: builder.query({
      query: () => ({
        url: `/api/resource/Driver`,
        method: 'GET',
      }),
    }),

getShipmentList: builder.mutation({
  query: (payload) => ({
    url: `/api/method/stackerbee_mobile_wms.wms.react_api.get_shipment_list`,
    method: 'POST', 
    body: payload,
  }),
}),
getPackingSlipByDeliveryNote: builder.query({
  query: (delivery_note) => {
    const filters = { 
      delivery_note: delivery_note, 
      custom_is_shipped: 0 
    };
    
    return {
      url: `/api/resource/Packing%20Slip`,
      params: {
        filters: JSON.stringify(filters),
        fields: JSON.stringify(["name", "gross_weight_pkg", "delivery_note"])
      },
      method: 'GET',
    }
  },
}),
getDeliveryNotesByCompany: builder.query({
  query: (company) => ({
    url: `/api/resource/Delivery Note`,
    params: {
      filters: JSON.stringify({
        company: company,
        custom_is_shipment_booked: 0
      }),
      fields: JSON.stringify(["name", "grand_total"]),
      limit_page_length: 0
    },
    method: 'GET',
  }),
}),


    getDriversByTransporter: builder.query({
      query: (transporterName) => ({
        url: `/api/resource/Driver`,
        method: 'GET',
        params: {
          filters: JSON.stringify({ transporter: transporterName }),
          fields: JSON.stringify(["name", "license_number", "full_name"]),
        },
      }),
    }),
   createShipment: builder.mutation({
      query: (payload) => ({
        url: `/api/method/stackerbee_mobile_wms.wms.react_api.create_shipment`,
        method: 'POST',
        body: payload,
      }),
    }),
        updateShipment: builder.mutation({
      query: (payload) => ({
        url: `/api/method/stackerbee_mobile_wms.wms.react_api.update_shipment`,
        method: 'POST',
        body: payload,
      }),
    }),
    submitShipment: builder.mutation({
      query: (payload) => ({
        url: `/api/method/stackerbee_mobile_wms.wms.react_api.submit_shipment`,
        method: 'POST',
        body: payload,
      }),
    }),
    getShipmentById: builder.query({
  query: (shipmentId) => ({
    url: `/api/resource/Shipment/${shipmentId}`,
    method: 'GET',
  }),
}),
getSalesInvoicesByCompany: builder.query({
  query: (company) => ({
    url: `/api/resource/Sales Invoice`,
    params: {
      filters: JSON.stringify({
        company: company,
        custom_is_shipment_booked: 0
      }),
      fields: JSON.stringify(["name", "grand_total"]),
      limit_page_length: 0
    },
    method: 'GET',
  }),
}),

getUniqueDeliveryNotesFromInvoice: builder.mutation({
  query: (payload) => ({
    url: `/api/method/stackerbee_mobile_wms.wms.api.get_unique_delivery_notes_from_invoice`,
    method: 'POST',
    body: payload,
  }),
}),



  }),
});

export const {
  useGetTransporterSuppliersQuery,
  useGetDriversQuery,
  useGetShipmentListMutation, 
  useGetPackingSlipByDeliveryNoteQuery,
  useLazyGetPackingSlipByDeliveryNoteQuery,
  useLazyGetDeliveryNotesByCompanyQuery ,
  useGetDriversByTransporterQuery,
  useLazyGetDriversByTransporterQuery,
  useCreateShipmentMutation,
  useUpdateShipmentMutation,
  useSubmitShipmentMutation,
  useGetShipmentByIdQuery,
  useLazyGetSalesInvoicesByCompanyQuery,
  useGetUniqueDeliveryNotesFromInvoiceMutation

} = shipmentApi;
